module.exports = __webpack_public_path__ + "img/footer-light.102ce038.svg";